export default [
  {
    type: 'update_date',
    content: 'تم التحديث في: ۲۲ ديسمبر ٢٠٢٢',
  },
  {
    type: 'text',
    content:
      '<strong>١.١</strong> تُشكل هذه الشروط والأحكام اتفاقاً ملزماً قانونياً أبرم بينك (سواء شخصياً أو بالنيابة عن كيان ما تمثله) و بين تمارا م.م.ح (“تمارا”) ويشار إليها فيما بعد ("نحن") ، فيما يتعلق بجميع جوانب خدمات الدفع من تمارا و/ أو استخدامكم للمنصة أو وصولكم إلى الموقع الخاص بنا <a target="_blank" href="https://tamara.co"> https://tamara.co</a> ، فضلاً عن أي شكل إعلامي آخر، أو قناة إعلامية ، أو موقع على شبكة الإنترنت أو تطبيق على الهاتف المحمول له صلة ، أو يرتبط به ومن خلال الوصول للمنصة واستخدامها. فإنك تقر بأنك قرأت هذه الشروط والأحكام، بصيغتها المعدلة من وقت لآخر، وفهمتها، ووافقت على الالتزام بها. وإذا لم توافق على هذه الشروط والأحكام، يتعين عليك التوقف عن استخدام المنصة أو الوصول إليها على الفور، وإذا كنت تستخدم المنصة بالنيابة عن طرف خارجي بما في ذلك، على سبيل المثال وليس الحصر، أي كيان عمل، فإنك تضمن بأنك مفوض وتتمتع بالسلطة لإلزام هذا الطرف الخارجي بهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١</strong> لا يُعتبر التاجر الذي تشتري منه السلع أو الخدمات باستخدام خدمات الدفع من تمارا طرفاً في هذه الاتفاقية، وتكون أية شروط سارية بينك وبين التاجر مستقلة عن شروط هذه الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١</strong> نحن نحتفظ بأحقيتنا، حسب تقديرنا المطلق، في إدخال تغييرات أو تعديلات على هذه الشروط والأحكام في أي وقت ولأي سبب كان.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١</strong> أنت تقر بمسؤوليتك بأن تستعرض هذه الشروط والأحكام بصورة دورية للاطلاع على آخر المستجدات، وتتنازل عن أي حق في تلقي إخطار محدد بكل تغيير من هذا القبيل، ويعد استمرارك في استخدام الموقع والمنصة بعد تاريخ نشر الشروط والأحكام المنقحة يعتبر إقراراً منك بأنك اطلعت على التعديلات وفهمت مضمونها وقبلت الالتزام بها.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١ </strong> يعتبر هذا التمهيد جزء لا يتجزأ من الاتفاقية.',
  },
  {
    type: 'subtitle',
    content: '٢. تعريفات',
  },
  {
    type: 'text',
    content:
      ' يقصد بالإشارات والألفاظ والعبارات والمصطلحات التالية المعاني المبينة أمام كل منها في هذه الشروط والاحكام:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٢</strong> الإشارات إلى الضمير “أنت“: تُعد الإشارات إلى الضمير “أنت“ أو ضمير الملكية للمخاطب (ك) أو أي ضمائر أخرى مماثلة في هذه الاتفاقية بمثابة إشارات إلى العميل المعني المشار إليه في معلومات التعريف (على النحو المحدد أدناه) المطلوب تقديمها قبل استخدام خدمات الدفع من تمارا (على النحو المحدد أدناه.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٢</strong> الإشارات إلى الضمير “نحن“: تُعد الإشارات باستخدام الضمير “نحن“ أو نون الجمع كضمير ملكية أو مفعول به أو أية ضمائر أخرى مماثلة في هذه الاتفاقية بمثابة إشارات إلى شركة تمارا والكيانات والأشخاص المنتسبين لها.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٢</strong> الموقع: يقصد به الموقع الإلكتروني الخاص بشركة تمارا <a target="_blank" href="https://tamara.co"> https://tamara.co</a>',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٢</strong> العميل: يقصد به عميل "التاجر أو منصة التجار "الذي يُنشئ حساب تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.٢</strong> التاجر: يقصد به أي كيان تجاري يقدم خدمات الدفع من تمارا لعملائه وفقاً لاتفاقية بينه وبين تمارا، أو بين تمارا ومنصة التجار.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.٢</strong> منصة التاجر: تعني الوسيلة، بما في ذلك على سبيل المثال لا الحصر المواقع الإلكترونية والتطبيقات، التي تسمح للعديد من التجار بعرض السلع والخدمات للعملاء من خلال منصة واحدة.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.٢</strong> الخدمات: يقصد بها الخدمات المقدمة من جانب شركة تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.٢</strong> طلب شراء: يقصد به الطلب المقدم من العميل من خلال المنصة أو الموقع الإلكتروني للتاجر أو أية تطبيقات أو نقطة بيع أخرى لاستخدام خدمة الدفع من تمارا لشراء سلع أو خدمات من التاجر.',
  },
  {
    type: 'text',
    content:
      '<strong>٩.٢</strong> خدمة الدفع من تمارا: الخدمة التي حددها العميل لدى التاجر أو على الموقع الإلكتروني لمنصة التجار أو في أي نقطة بيع أخرى لدى التاجر أو على منصة التجار والتي يختار بموجبها العميل شراء السلع أو الخدمات من التاجر أو منصة التجار باستخدام خدمات تمارا الخاضعة لهذه الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٢</strong> حساب تمارا: يقصد به الحساب الذي أنشأه العميل لاستخدام خدمات الدفع من تمارا ، والذي سيخضع استخدامه وتشغيله لشروط وأحكام هذه الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>١١.٢</strong> عملية الدفع: يقصد بها العملية التي يمر بها العميل عند اختيار استخدام خدمات الدفع المتاحة بواسطة موقع تمارا فيما يتعلق بطلب شراء معين.',
  },
  {
    type: 'text',
    content:
      '<strong>١٢.٢</strong> استرداد المدفوعات: المبلغ الذي يدفعه العميل إلى التاجر عن طريق تمارا فيما يتعلق بمعاملة معتمدة وتتم إعادته بعد ذلك إلى العميل عقب النزاع.',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.٢</strong> النزاع: أي طلب استرداد أو خصم أو تعويض أو مطالبة مضادة أو خلاف من أي نوع من جانب العميل ضد التاجر فيما يتعلق بالسلع أو الخدمات التي أدت إلى معاملة معتمدة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٢</strong> معلومات التعريف: يقصد بها المعلومات المطلوب تقديمها من العميل إلى تمارا من أجل إنشاء حساب له لدى تمارا حسبما يتم جمعها بواسطة تمارا أو التاجر أو منصة التجار لأغراض تقديم خدمات الدفع من تمارا للعملاء.',
  },
  {
    type: 'text',
    content:
      '<strong>١٥.٢</strong> معلومات المعاملة: يقصد بها جميع المعلومات المتعلقة بطلب الشراء.',
  },
  {
    type: 'text',
    content:
      '<strong>١٦.٢</strong> صافي المبلغ: يقصد به المبلغ الإجمالي الذي يجب أن يدفعه العميل [بما في ذلك أي ضريبة قيمة مضافة ورسوم شحن] فيما يتعلق بطلب الشراء الذي ينشأ عنه معاملة معتمدة واحدة مطروحاً منه:',
  },
  {
    type: 'list',
    content: [
      '(أ) أية مرتجعات.',
      ' (ب) أية خصومات أو ائتمانات أو تخفيضات يطالب بها العميل وتتم الموافقة عليها من قبل التاجر المعني. ',
    ],
  },
  {
    type: 'text',
    content:
      '<strong>١٧.٢</strong> القوة القاهرة : ويُـقصد بها أي حدث قدري، أو حادث فجائي غير ممكن توقعه ويستحيل دفعه، ومن ذلك على وجه العموم لا الحصر الحريق والفيضانات والعواصف والأعاصير والزوابع والنشاطات البركانية والزلازل، وكذا أية تصرفات أو أوامر أو طلبات تصدر من جهة سيادية أو حكومة و/أو أية هيئة يُـفترض أنها تعمل لصالح تلك الجهة، وكذا الحرب، سواء المعلنة أو غير المعلنة، والتصرفات المثيلة للحرب، والثورات، وحالات الشغب، والعصيان المدني، والاضطراب المدني، وكذا عمليات الاضراب، والتوقف عن العمل، و/أو ما شابة ذلك من حالات، وأي سبب آخر مثيل ويخرج عن نطاق تحكم أو سيطرة أي طرف، هذا ما لم يكن تنفيذه هو تنفيذ محل ضمان يسري بموجب تنازل صريح عن الإعفاء في حالة وقوع حدث القوة القاهرة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٢</strong> القوانين واجبة التطبيق: ويقصد بها الأنظمة السارية لدى المملكة العربية السعودية والتي تنطبق على الاتفاقية.',
  },
  {
    type: 'subtitle',
    content: '٣. الأهلية والصلاحية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٣</strong> يعد استخدامك لخدمات الدفع من تمارا إقراراً منك بأهليتك الشرعية والقانونية لإبرام الاتفاقية الماثلة وفق هذه الشروط والأحكام واقراراً منك بأنك تجاوزت سن الثمانية عشر (١٨) عاماً.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٣</strong> وإذا قمت بالتسجيل بصفتك جهة عمل أو شخص اعتباري أو أي كيان آخر، فيكون إقرارا منك بأن لديك الصلاحية والأهلية اللازمة لإبرام الاتفاقية الماثلة ولإلزام الكيان الخاص بك بالشروط والأحكام الماثلة، وأنك كذلك كيان العمل ستلتزم بكل ما هو واجب التطبيق من قوانين واشتراطاتٍ تسري على - وتخضع لها- عملية استخدام الموقع الإلكتروني واستخدام خدمات الدفع من تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٣</strong> وأن قيامك بالنقر على الموافقة على شروط هذه الاتفاقية يعتبر إقراراً منك أنك قد أبرمت هذه الاتفاقية إلكترونياً وفقاً للأنظمة المعمول بها في المملكة العربية السعودية.',
  },
  {
    type: 'subtitle',
    content: '٤. الحسابات والتسجيل:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٤</strong> يستلزم منكم عملية تسجيل الحساب وإتمام الاتفاقية أن تتقدموا إلى تمارا بمعلوماتٍ شخصية مُعينة لأغراض اعرف عميلك المعمول بها في المملكة، ومنها على وجه العموم لا الحصر الاسم بالكامل والعنوان والبريد الإلكتروني ورقم الهاتف والعمر، فأنت تقر وتوافق على أن يتم حفظ معلوماتٍ صحيحة ودقيقة وكاملة بل ومُحدثة بشأنكم على الحساب ، وإخطار تمارا على الفور بأية تغييرات تطرأ على معلومات التعريف الخاصة بك أو أية معلومات أو ظروف أخرى قد تؤثر على أهليتك للاستمرار في استخدام خدمات الدفع من تمارا أو تكون مطلوبة بخلاف ذلك وفقًا لشروط هذه الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٤</strong> أنت توافق بموجب هذه الاتفاقية على الإفصاح عن كافة المعلومات التي قد تكون مؤثرة أو ذات أهمية إلى اي طرف من أطراف اتفاقية التمويل.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٤</strong> أنت توافق بموجب هذه الاتفاقية على أن تتحمل المسؤولية عن كل نشاطٍ يجري في إطار حسابك، كما تلتزم بالموافقة على الحفاظ وباستمرار على سريان إجراءاتٍ أمنية على اسم المستخدم وكلمة المرور الخاصة بحسابك، هذا ما لم تصرح تمارا بغير ذلك كتابة.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٤</strong> إذا فُقدت أو سُرقت كلمة المرور الخاصة بك، أو إذا كنت تعتقد أن هناك وصولًا غير مصرح به إلى حساب تمارا الخاص بك، فيجب عليك تغيير كلمة المرور الخاصة بحساب تمارا وإخطارنا فورا، ويتحمل العميل مسؤولية أي معاملات تتم بإستخدام حسابه المسروق ما لم يبادر على الفور بإخطارنا بتعليق الحساب وتلقي رسالة من تمارا تفيد وتأكد غلق الحساب.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.٤</strong> وحيث أنه لا يجوز نقل أو حوالة حسابات المستخدم، فلهذا فأنت تقر وتوافق على أن ترد إلى تمارا قيمة أية عملية استخدام لحسابكم ، ولم تكن عملية صحيحة أو مُصرح بها أو تسري وفق القانون، وحدث ذلك من جانبك أو من جانب أي شخص يمكنه الدخول على الموقع الإلكتروني أو الخدمات أو خلافه من خلال استخدام اسم المستخدم أو كلمة المرور المحددة من جانبكم، بل وسواء سمحتم بذلك الدخول أم لا.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.٤</strong> وإذا كان لدى تمارا (وحسب مطلق اختيارها) ثمة شكوك بأن أية معلومة من المعلومات التي تقدمت بها هي معلومة غير صحيحة أو غير دقيقة أو غير كاملة أو غير محدثة، دونما إخلال بأية حقوق أخرى وتعويضاتٍ مكفولة لدى شركة تمارا، وفق الشروط والاحكام الماثلة أو بمقتضى القوانين واجبة التطبيق، فيكون لدينا الحق في إيقاف خدماتنا وإيقاف عملية دخولكم على الموقع الإلكتروني أو خدماته، أو تحديد هذا الدخول أو قصره.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.٤</strong> ويجوز لدى تمارا القيام (وحسب مطلق اختيارها بل وفي أي حين) بإبداء أية استفسارات تراها ضرورية (سواء تم ذلك بصورة مباشرة أو من خلال طرف من الغير)، وكذا وكذلك مطالبتكم بتقديم الرد وبمزيد من المعلومات أو المستندات، ودونما تقييد بما سلف بيانه، فإذا كنتم بمثابة جهة عمل أو مُسجلين بالنيابة عن جهة عمل، فيجوز أن تشمل هذه المعلومات أو المستندات الترخيص التجاري وغير ذلك من مستنداتٍ رسمية خاصة بالشركة و/أو مستنداتٍ تستعرض أية صلاحية مكفولة لأي شخص للعمل نيابة عنكم. فأنت تقر وتوافق على توفير أية معلوماتٍ و/أو مستندات إلى تمارا فور طلبها إياها. كما تقر وتوافق على أنه إذا تعذر عليك القيام بذلك، فيجوز لتمارا القيام ودونما أية مسؤولية عليه بتقييد أو إيقاف أو سحب عملية دخولكم على الموقع الإلكتروني. كما نحتفظ أيضا بالحق في إلغاء أية حساباتٍ لم يرد تأكيد بشأنها أو لم يتم التحقق منها أو أية حساباتٍ لم تكن مفعلة لمدة طويلة.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.٤</strong> وعند إتمام عملية التسجيل من جانبك فإنك تقر وتوافق بأنك اطلعت على الشروط والأحكام الماثلة بل وتفهمتها ووافقت على الالتزام بها، وكذلك سياسة الخصوصية بل وكل ما يطرأ عليها من تعديل من حين لآخر، حيث تعتبر السياسة وتعديلاتها - وبموجب هذه الاتفاقية - بمثابة جزء لا يتجزأ بل وتندرج ضمن الشروط والاحكام الماثلة.',
  },
  {
    type: 'subtitle',
    content: '٥. الخدمات',
  },
  {
    type: 'text',
    content:
      '<strong>١.٥</strong> تعتبر تمارا بمثابة سوق إلكتروني مصمم ليكون حلقة وصل كمركز تجارياً شاملاً للعديد من المحلات التجارية الكبرى عن طريق التعاقد مع أصحاب هذه المواقع او المحلات، ويتمثل هدفنا في القيام بتوفير دليل إرشادي لكبار المحلات التجارية وإعطاء العميل ميزة خيار الشراء الآن والدفع لاحقاً للعملاء مع إمكانية تقسّيم الفاتورة على 3 أو 6 دفعات ميسرة.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٥</strong> يعرض موقع تمارا منتجات يوفرها ويملكها تجار على منصاتهم الخاصة مستقلين ممن وافقوا على وضع قائمة بهذه المنتجات على الموقع الإلكتروني وقد اتفق هؤلاء التجار كتابة مع تمارا على القيام بتوفير المنتجات محل الطلبيات من خلال منصاتهم الإلكترونية.',
  },
  {
    type: 'text',
    content:
      '<strong>۳.٥</strong> رسوم الخدمة سيتم تطبيقها على خدمة "ادفعها بداية الشهر" وخدمة " قسم فاتورتك على 3 دفعات" على متاجر مُختارة. قيمة الرسوم موضحة عند الدفع، للتأكد يرجى مراجعة قيمة الطلب قبل الإنتهاء من عملية الشراء.',
  },
  {
    type: 'subtitle',
    content: '٦. المراسلات و التواصل الالكتروني',
  },
  {
    type: 'text',
    content:
      '<strong>١.٦</strong> عند انشاء حساب، فإنك تقر وتوافق على أنك ستتواصل معنا الكترونياً، وبالتالي توافق على استلام رسائل دورية من جانبنا وسوف يتواصل معك فريق تمارا عبر البريد الإلكتروني أو قد يرسل لكم معلوماتٍ عبر رسائل نصية قصيرة، وكذا القيام بنشر إخطاراتٍ على الموقع الإلكتروني كجزء من إدارة الأعمال المعتادة والتي ترتبط بعملية استخدامك للخدمات، وإنك تقر وتوافق بأن اختياركم عدم تطبيق وسائل التواصل المذكورة هو أمر من شأنه إحداث ثمة تأثير على عملية استخدامكم للخدمات.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٦</strong> لضمان تمكننا من التواصل معك إلكترونيًا، فأنت توافق على إخطارنا فوراً بأي تغيير في عنوان بريدك الإلكتروني أو أية معلومات أخرى تقدمها لنا ونتواصل معك وفقًا لها، بما في ذلك رقم هاتفك، من خلال تحديث معلومات التعريف وأية معلومات أخرى ذات صلة بحساب تمارا في أقرب وقت ممكن عملياً وعند الضرورة.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٦</strong> وإنك تقر وتوافق على أن تكون جميع الاتفاقات والاخطارات والافصاحات وغير ذلك من مراسلاتٍ مما نقوم بتقديمه اليكم الكترونيا هي مراسلاتٍ تستوفي أي اشتراط قانوني يستلزم تقديم تلك المراسلات على نحو كتابي.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٦</strong> كما سيطلب منك موقع تمارا خلال عملية التسجيل الموافقة على أن نرسل لك رسائل بريد الكترونية أو إخطاراتٍ دعائية ترتبط بالموقع الإلكتروني وما به من خدمات، وأنت توافق على استلام رسائل نصية قصيرة لكل رقم هاتف تقدمه إلى تمارا، كما تقر بأنك المستخدم الرئيسي لرقم الهاتف الذي قدمته لنا، وتقر بأنه مسموح لك بتلقي رسالة نصية قصيرة على رقم الهاتف الذي قدمته لنا. كما توافق على تنبيهنا كلما توقفت عن استخدام رقم هاتف معين وإذا حدث في أي حين أن قررت أو أبديت عدم الرغبة في استلام رسائل البريد الإلكتروني الدعائية، فيمكنك اختيار عدم استلامها من خلال الضغط على الرابط الكائن في اسفل أية رسالة بريد إلكتروني دعائية.',
  },
  {
    type: 'subtitle',
    content: '٧. حقوق الملكية الفكرية والعلامات التجارية',
  },
  {
    type: 'text',
    content:
      '<strong>١.٧</strong> بالنسبة لجميع المحتوى الوارد على الموقع الإلكتروني، ومن ذلك على وجه العموم لا الحصر النص، وصور الجرافيك، وشعارات تمارا ، والازرار، والصور، والمقاطع الصوتية، وعمليات التحميل الرقمي، وتجميع البيانات، والبرامج الإلكترونية، فيعتبر ذلك المحتوى بمثابة ملكية بل وعمل تأليفي خاص بتمارا أو بمرخصيه، كما يخضع هذا المحتوى للحماية بموجب حق المؤلف وحقوق العلامات التجارية وبراءات الاختراع وغير ذلك من حقوق ملكية فكرية وقوانين. كما يكون المحتوى المجمع على الموقع الإلكتروني بمثابة ملكية حصرية لتمارا بل وحق تأليف لها، بل ويخضع للحماية بموجب حق المؤلف وحقوق العلامات التجارية وبراءات الاختراع وغير ذلك من حقوق ملكية فكرية وقوانين.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٧</strong> وتعتبر علامة تمارا وما يرتبط بها من رموز هي علاماتٍ تجارية خاصة ب تمارا ، علما بأنه لا يجوز استخدام العلامات التجارية لتمارا فيما يتعلق بأي منتج أو أية خدمة ليست معروضة على تمارا ، أو أي منتج أو خدمة من شأنها التقليل من شأن تمارا أو الإساءة لسمعتها.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٧</strong> يحظر على العميل استخدام أية علامة تجارية أو أي حقوق ملكية فكرية تخص تمارا ، وذلك من أي جزء من الخدمات، كما يحظر عليه إعادة إنتاج الخدمات أو تعديلها أو إجراء أية عملية إعداد أو نشر أو تنفيذ أو إرسال أو عرض أو بث أو غير ذلك من وسائل استغلال الخدمات، هذا ما لم تسمح تمارا بذلك أو يأذن صراحة وبصورة كتابية، كما لا يجوز إجراء اعمال تفكيك لنظام الخدمات أو أية هندسية عكسية أو إعادة تشكيل لها، أو القيام بربط أي جزء من الخدمات بأي نظام عاكس أو تأطيره أو وضع أية برامج أو نصوص لغرض إزالة أي جزء من الخدمات أو فهرستها أو مسحها أو إجراء غير ذلك من عمليات استخراج للبيانات منه، أو القيام بتحميل عملية التشغيل و/ أو العمل الوظيفي لأي منحى من مناحي الخدمات بأحمال لا مبرر لها أو القيام بإعاقتها أو محاولة الحصول على إمكانية الدخول عليها دونما تصريح بذلك أو العمل على الإضرار بالخدمات أو ما يرتبط بها من أنظمة أو شبكات.',
  },
  {
    type: 'subtitle',
    content: '٨. استخدام الموقع الإلكتروني',
  },
  {
    type: 'text',
    content:
      '<strong>١.٨</strong> يحظر على العميل استخدام الموقع الإلكتروني لتمارا للدعاية عن منتج له أو القيام في قسم مراجعة المنتج (الخاص بالمنتجات المقيدة) أو في أي موضع آخر بالموقع (وذلك حسبما يتقرر وحسب مطلق اختيارنا) بأية عملية نشر للآتي: أية دعاية لغرض الاستقطاب أو أية إعلانات أو استخدام لغة مبتذلة أو مواد تشوبها البذاءة أو تحتوي على سباب أو تجاوزات من الناحية الثقافية أو الدينية أو أي محتوى سياسي نقدي أو مواد من شأنها إحداث تهديد للصالح العام أو الأمن القومي أو التسبب في إساءة السمعة أو القذف أو التشهير أو أي محتوى آخر قد تشوبه الإهانة أو البذاءة أو عدم اللياقة.',
  },
  {
    type: 'subtitle',
    content: '٩. قوائم المنتجات ومدى توافرها',
  },
  {
    type: 'text',
    content:
      '<strong>١.٩</strong> وستعمل تمارا دائماً على أن تقدم لك أفضل الخبرات بل ومستوى متميز من الخدمة حيث تبذل تمارا قصارى جهودها لتضمن أن منتجات المورد منتجاتٍ متاحة ومتوفرة، إلا أن تمارا لا تتحمل أي مسؤولية في حال عدم توافر أي منتجات لدى أي تاجر وكانت هذه المنتجات معروضة على الموقع الإلكتروني.',
  },
  {
    type: 'subtitle',
    content: '١٠. خدمة ما بعد البيع للمنتجات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٠</strong> تعتبر المنتجات المُباعة من خلال الموقع الإلكتروني الماثل والتي لا تحمل الاسم التجاري لتمارا هي منتجات يتم تقديم الخدمات بشأنها ودعمها من خلال التجار مصنعيها أو الوكلاء المحليين لها فقط وكذا مورديها، وذلك وفق الشروط والاحكام المرتبطة بكل منتج. كما لا تمنح تمارا أي ضمان من أي نوع بالنسبة للمنتجات المباعة على الموقع الإلكتروني. ولهذا يُرجى التواصل مع التجار عند الحاجة للدعم الفني أو خدمة العملاء أو خدمة ما بعد البيع فيما يتعلق بمنتجاتهم.',
  },
  {
    type: 'subtitle',
    content: '١١. المدفوعات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١١</strong> بمجرد إنشاء حساب لدى تمارا وفقاً لهذة الاتفاقية تمنحك تمارا القدرة على طلب استخدام خدمات الدفع من تمارا عندما تختار الدفع للحصول على السلع أو الخدمات باستخدام خيار الدفع الخاص بخدمات الدفع من تمارا لدى التاجر المعني أو على الموقع الإلكتروني الخاص بمنصة التجار.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١١</strong> تسمح لك خدمات الدفع من تمارا بشراء سلع أو خدمات من تاجر أو منصة تجار مع الدفع في وقت لاحق على أساس شروط السداد المحددة أثناء عملية الدفع وقد تشمل شروط السداد هذه مبالغ تأخير على النحو المحدد في عملية الدفع من خلال إبرام هذه الاتفاقية، أنت توافق وتقر بأنك قد فهمت وقبلت جميع الرسوم المرتبطة بطلب الشراء الخاص بك على النحو المحدد في عملية الدفع ، أما ما يتعلق بمبالغ التأخير فإنك تتعهد بدفعها لتمارا على أن تقوم تمارا بالتصدق بها في وجوه الخير تحت إشراف اللجنة الشرعية.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١١</strong> بمجرد أن تختار خدمة الدفع من تمارا في نقطة البيع الخاصة بالتاجر أثناء عملية الدفع، سيُطلب منك أن تختار من بين مجموعة من شروط السداد التي ستصبح سارية وملزمة فيما بينك وبين تمارا فيما يتعلق بطلب الشراء هذا. وتوفر تمارا وسائل سداد مختلفة على الموقع الإلكتروني منها السداد الكترونياً من خلال بطاقات الائتمان.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١١</strong> وتحتفظ تمارا بالحق في إجراء أي تغيير أو تعديل في وسيلة السداد أو عملية توفيرها.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١١</strong> توفر تمارا خدمات سداد الكتروني من خلال مقدمي خدمة من الغير، علماً بأن تمارا لا تقوم بتخزين أية بياناتٍ ترتبط ببطاقات الائتمان ، ولا تتحمل تمارا أي مسئولية عن أي خطأ أو ضرر أو أي أمر مثيل قد يتعرض له العميل من واقع أو جراء استخدام وسيلة السداد الإلكتروني، حيث يقع ذلك على مسئولية مقدم الخدمة من الغير.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١١</strong> ويكون على العميل أن يضمن وجود تغطية مالية كافية في الحساب ذو الصلة، بحيث يُمكن تغطية الطلبيات، كما يكون عليه الالتزام بحدود معاملات بطاقة الائتمان.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١١</strong> بموجب هذه الاتفاقية فأنت (العميل) توافق وتفوض تمارا في سحب المبلغ من حساب البطاقة المخزنة في حسابك (حساب العميل) لدى تمارا في التاريخ المستحق للسداد . وفي حال تم رفض العملية لعدم وجود مبالغ تغطي القسط سوف يتم المحاولة كل يومين (يوم نعم ويوم لا) لحين سداد المبلغ كاملا.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.١١</strong> قد تفرض تمارا رسوم إضافية على المستخدمين من واقع إجراء عملية السداد الكترونياً.',
  },
  {
    type: 'text',
    content:
      '<strong>٩.١١</strong> ويجوز لتمارا القيام (وحسب مطلق اختيارها بل وفي أي حين) بإبداء أية استفساراتٍ تراها ضرورية (وذلك سوءاً بصورة مباشرة أو من خلال الغير)، كما يجوز لها أن تطلب منكم موافاتها بالمزيد من المعلومات أو المستندات، ومن ذلك على وجه العموم لا الحصر أية معلومات أو مستندات تلزم للتحقق من هويتكم و/أو ملاءتكم المالية. فأنت تقر وتوافق على توفير أية معلوماتٍ و/أو مستنداتٍ إلى تمارا فور طلبه إياها. كما إنك تقر وتوافق الإقرار والموافقة على أنه إذا تعذر عليكم ذلك، فيجوز لتمارا القيام - ودونما أية مسئولية عليها- بإلغاء المعاملة أو تقييد أو إيقاف إمكانية دخولكم على الموقع الإلكتروني و/أو سحب عضويتكم منه.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١١</strong> بموجب هذه الاتفاقية، انت تقر بملائتك المالية وقدرتك على الوفاء بجميع الالتزامات المالية لتمارا، كما توافق على علمك المسبق بأن تمارا لديها الحق في التعاون مع التاجر مقدم الخدمة أو البضاعة في حال تخلفك عن سداد الدفعات. هذا التعاون قد يشمل (ايقاف الاشتراك أو الخدمة، الحجز على المنتج أو البضاعة) لحين اكتمال سداد الدفعات',
  },
  {
    type: 'text',
    content:
      '<strong>١١.١١</strong> أنت توافق بموجب هذه الاتفاقية على تفهمك وتحملك للعواقب المحتملة عند استخدام الخدمة التمويلية خلافاً للشروط المتفق عليها. وتوافق على أحقية تمارا (وحسب مطلق اختيارها) بإخطار الشركة السعودية للمعلومات الائتمانية ("سمة") في حالة تأخرك أو عجزك عن السداد.',
  },
  {
    type: 'text',
    content:
      '<strong>١١.١٢</strong> أنت توافق بموجب هذه الاتفاقية على أنك المستفيد الحقيقي من هذه الاتفاقية وأنك لا تستخدم خدمات تمارا في أي من عمليات غسل الأموال.',
  },
  {
    type: 'subtitle',
    content: '١٢. استرداد المدفوعات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٢</strong> تمارا ليست مسؤولة تجاهك فيما يتعلق بأي عملية استرداد مدفوعات، في حين أن تمارا قد تؤدي دوراً في تسهيل عمليات استرداد المدفوعات وإعادة الأموال فيما بينك وبين التاجر أو منصة التجار وفقاً لتقديرها المطلق، فإن هذا الدور لا ينطوي على أية مسؤولية فيما يتعلق باسترداد المدفوعات.',
  },
  {
    type: 'subtitle',
    content: '١٣. السرية والخصوصية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٣</strong> تلتزم (تمارا) بكافة الطرق المهنية المعقولة في المحافظة على سرية المعلومات الائتمانية والبيانات التي في حوزتها، وعدم استخدامها أو تبادلها فيما بينها وبين الأشخاص والأطراف ذوي العلاقة إلا في حدود ووفق ما ورد في نظام المعلومات الائتمانية ولائحته التنفيذية.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٣</strong> أنت توافق بموجب هذه الاتفاقية على تقديم أية معلومات، بما في ذلك معلومات التعريف أو الوثائق المطلوبة بشكل معقول من جانب تمارا للتحقق من هويتك فيما يتعلق بحساب تمارا أو أي استخدام لخدمات الدفع من تمارا، وتصرح لنا بطرح أية استفسارات نعتقد أنها ضرورية من أجل التحقق من هويتك. وتحتفظ تمارا بالحق في إغلاق حساب تمارا الخاص بك أو تعليق وصولك إلى خدمات الدفع من تمارا أو تقييده إذا تعذّر علينا الحصول على أي من هذه المعلومات أو التحقق منها على نحوٍ يُرضينا.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٣</strong> أنت توافق بموجب هذه الاتفاقية وتفوض تمارا في استخدام أي من أو جميع معلومات التعريف و البيانات الشخصية الخاصة بك التي تم جمعها من خلال المواقع الإلكترونية أو المنصات أو تطبيقات الهواتف المحمولة الخاصة بتمارا أو التجار من وقتٍ لآخر ويجوز استخدامها أو الإفصاح عنها إلى أشخاص آخرين . وقد يشمل ذلك مشاركة معلومات التعريف الخاصة بك وأية معلومات أخرى مع أطراف خارجية لأغراض التحقق من الائتمان ومكافحة غسل الأموال أو غيرها من الفحوصات المماثلة أو لأي غرض آخر تعتبره تمارا ضروريًا من أجل تمكين تمارا من تقديم خدمات الدفع لك والالتزام بجميع القوانين واللوائح المعمول بها.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١٣</strong> أنت توافق بموجب هذه الاتفاقية وعند الدخول أو استخدام المواقع الإلكترونية أو تطبيقات الهواتف المحمولة الخاصة بتمارا، على سياسة السرية، مع إدراكك وعلمك بأنه يتم تجميع معلوماتك الشخصية وتفهمك لكيفية التعامل معها.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١٣</strong> إذا كنت لا توافق على سياساتنا وممارساتنا، فلن تتمكن من استخدام المواقع الإلكترونية أو تطبيقات الهواتف المحمولة الخاصة بتمارا ويرجى عدم متابعة استخدام خدماتنا.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١٣</strong> يحق للعملاء سحب موافقتهم على معالجة بياناتهم الشخصية في أي وقت، وفقًا للقيود التعاقدية والقانونية والإشعار الكتابي.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١٣</strong> لا تسمح تمارا للعميل (المتعاقد مع تمارا) الإفصاح للغير عن أية معلوماتٍ ترد إليه بموجب هذه الاتفاقية أو عقد خدمة مُـبرم مع تمارا ، بل وينبغي أن لا يتم الدخول على أية معلوماتٍ ترتبط بأعمال تمارا على نحو تشمله السرية، وذلك في الحدود التي قد تؤثر سلباً على أعمال تمارا، ويتحمل العميل المسؤولية عن تعويض تمارا عن أية خسارة في العمل أو في السمعة، إن حدث ذلك جراء أي تصرف يقع من العميل.',
  },
  {
    type: 'subtitle',
    content: '١٤. حدود المسئولية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٤</strong> تعتبر تمارا بمثابة منصة مستقلة، لا تشارك في المعاملات التي تجري بين العملاء والتجار والبائعين أو التعاملات الأخرى المشاركة ذات الصلة، ومن ثم لا تتحمل تمارا المسئولية بأي حال من الأحوال عن أي وضع من الأوضاع المرتبطة بالتجار ولا تتحمل أي مسؤولية عن أي إخفاق يرتبط بمنتجات التجار أو طراز المنتجات او علامتها أو مصداقيتها أو كفاءتها أو اصليتها أو توافرها أوقانونيتها.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٤</strong> ويعتبر التجار من الغير عن هذه الاتفاقية وبمثابة مقدمي خدماتٍ مستقلين ومتعاقدين فقط مع تمارا، ولا يجوز اعتبارهم عاملين لدى تمارا أو ممثلين لها أو وكلاء عنها. كما أن تمارا لا تؤدي المهام بنفسها، بل تتولى إدارة عملية تنفيذ المهام من خلال منصتها الإلكترونية وذلك من خلال توفير عملية تواصل بين العميل والتاجر، ويتحمل التجار المسئولية الكاملة عن كافة التعاملات التي تجري بينهم و بين العملاء أو التعاملات الأخرى ذات الصلة، وفي حالة نشوء نزاع بين أي طرف من المشاركين في هذه المعاملات، يتعهد كل من العملاء والمستخدمين والتجار على إعفاء تمارا من أي مسؤولية ناتجة أو مرتبطة عن أية نزاعاتٍ بين أي طرف بأي حال من الأحوال. والتعهد بإعفاء تمارا (ووكلائها وموظفوها) من المطالبات، والطلبات، والمسؤوليات والتعويضات أياً كان نوعها أو طبيعتها، وسواء كانت معروفة أو غير معروفة، وسواء كان مفصح عنها أم غير مفصح عنها، والتي تنشأ عن أو تتعلق بأي شكل من الأشكال بتلك النزاعات.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٤</strong> بموجب الموافقة على هذه الاتفاقية تقر بعلمك وتفهمك باحتمال وقوع مخاطر من التجار أو أخطاء منهم أو من مقدمي الخدمة من الغير، بالتالي يكون استخدام الخدمات أمر يقع على مسؤولية العميل ووفقاً لقراره، ولا تتحمل تمارا أي مسئولية تجاهه.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١٤</strong> ولا تتحمل تمارا أية مسئولية تجاهك أو تجاه أي شخص آخر، عما قد ينشأ من أضرارٍ مباشرة أو غير مباشرة أو عارضة أو خاصة أو جزائية أو عقابية أو تبعية، حتى لو أبلغت تمارا ما يفيد باحتمال وقوع تلك الأضرار، كما لا تتحمل تمارا المسئولية عن أية أضرار أو التزاماتٍ أو خسائر تتحملونها، وكانت تنشأ من واقع استخدامكم أو اعتمادكم على الخدمات أو جراء عدم أمكانية دخولكم على الخدمات أو استخدامها أو من واقع أية معاملة أو علاقة نشأت بينكم وبين أي تاجر من التجار، بل وحتى لو ورد لتمارا ما يفيد باحتمال وقوع تلك الأضرار. ولا تتحمل تمارا أيضا المسئولية عن أي تأخير أو إخفاق في التنفيذ، كما لا تتحمل المسئولية في حالة احتمال عدم حيازة التاجر تصريح مهني أو تخصصي بالعمل.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١٤</strong> يتم تقديم الخدمات كما هي معروضة وحسبما هو متاح منها، وتعفى تمارا بل وتبرأ من كافة الاقرارات والضمانات الصريحة منها أو الضمنية أو القانونية التي لم يرد نصها صراحة في الشروط الماثلة، ومن ذلك الضماناتٍ المعروضة ضمناً بشأن قدرة البائع وملاءمة خدماته لغرض معين وعدم إخلاله بها، كما لا تقدم تمارا أي إقرار أو ضمان بشأن مصداقية الخدمات أو البضائع أو جودتها أو استدامتها أو توافرها أو مالكها الأصلي هي أو أية خدمات تطلب من خلال استخدام خدمات تمارا، كما لا تضمن تمارا عدم تعرض الخدمات للتعطيل أو خلوها من الخطأ. ولهذا فأنت تقر وتوافق على تحملك حصرا كامل المسئولية الناشئة عن استخدامك لأي من الخدمات التي تقدمها تمارا، وذلك إلى أقصى حد يسمح به القانون واجب التطبيق.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١٤</strong> تعتبر المعلومات الواردة في الموقع الإلكتروني هي معلومات معروضة لأغراض عامة فقط، أما بالنسبة للمعلومات التي ترد من جانب تمارا، فنحن نبذل بشأنها جهودنا للعمل على أن تظل المعلومات معلوماتٍ محدثة وصحيحة، إلا أننا لا نتقدم بأية إقراراتٍ أو ضمانات من أي نوع، سواء على نحو شفهي أو ضمني، وذلك من حيث اكتمال أو دقة أو مصداقية أو ملاءمة أو توافر الموقع الإلكتروني أو المعلومات أو الخدمات أو ما يرتبط به من إعلانات أو رسوم جرافيك واردة على الموقع الإلكتروني بالنسبة لأي غرض، وبالتالي يكون اعتمادك على تلك المعلومات هو أمر يقع على مسؤوليتك الخاصة تماما.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١٤</strong> تعتبر جميع الحسابات المسجلة على تمارا هي حسابات محل متابعة مستمرة، وذلك لأغراض أمنية ولأسبابٍ تتعلق بالأداء.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.١٤</strong> لا تتحمل تمارا المسئولية عن أي تأخير أو إعاقة أو إخفاق في توفير الخدمات، إن كان السبب فيها يرجع إلى حدث قوة قاهرة أو ما شابهه من أحداث تخرج عن نطاق تحكمنا أو سيطرتنا وكان من شأنها منع عملية تقديم الخدمة أو إعاقتها.',
  },
  {
    type: 'text',
    content:
      '<strong>٩.١٤</strong> أنت تقر وتوافق بموجب هذه الاتفاقية على إبراء ذمة شركة تمارا وأي من شركاتها التابعة ومسؤوليها ومديريها وموظفيها ووكلائها من وضد أية مطالبات أو مسؤوليات أو أضرار أو خسائر أو نفقات أو تعويضها وإخلاء مسؤوليتها عن ذلك، بما في ذلك على سبيل المثال لا الحصر، الرسوم القانونية والمحاسبية الناشئة عن أو بأي طريقة تتعلق بما يلي:',
  },
  {
    type: 'subtitle',
    content: [
      '(أ) وصولك إلى حساب تمارا أو خدمات الدفع من تمارا أو استخدامها أو عدم القدرة على استخدامها.',
      '(ب) إهمالك أو سوء سلوكك.',
      '(ج) انتهاكك لأي قانون معمول به.',
      '(د) إخفاقك في تقديم المعلومات الصحيحة والدقيقة والحديثة والكاملة فيما يتعلق بحساب تمارا الخاص بك والاحتفاظ به.',
    ],
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٤</strong> إذا لم توافق على أي من هذه الشروط والأحكام في الاتفاقية، فيكون عليك عدم الدخول إلى الموقع وعدم استخدام خدمات تمارا.',
  },
  {
    type: 'subtitle',
    content: '١٥. التعويض:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٥</strong> أنت تقر وتوافق على تعويض ودرء الضرر عن تمارا وكياناتها التابعة لها والجهات الراعية له وشركائه ومديرية ومسئوليه وعامليه بل ورد قيمة جميع الخسائر لها/لهم وكذا قيمة الأضرار والمسئوليات والمطالبات والأحكام والتسويات والغرامات والتكاليف والمصروفات (ومنها أي مصروفات ورسوم قانونية وتكاليف تحقيقات وأتعاب المحاماة)، في حال تعرض تمارا لأي أضرار بسببك أو إذا نشأت أو ارتبط بإخلالك بالاتفاقية والشروط والأحكام الماثلة أو سياسة الخصوصية أو استخدامك أو استخدام الغير (من طرفكم) للخدمات.',
  },
  {
    type: 'subtitle',
    content: '١٦. الإخطارات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٦</strong> يجب أن تكون جميع الإخطارات والمراسلات الأخرى بموجب هذه الاتفاقية كتابةً عبر المراسلات إلى البريد الإلكتروني لشركة تمارا الموضح على موقع تمارا الإلكتروني في حال كنت ترغب في إخطار تمارا أو التواصل معها خلاف ذلك، وذلك عن طريق عنوان بريدك الإلكتروني أو رقم هاتفك الذي قمت بتقديمه لشركة تمارا وفقاً لشروط هذه الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٦</strong> لضمان تمكننا من التواصل معك إلكترونياً، فأنت توافق على إخطارنا فوراً بأي تغيير في عنوان بريدك الإلكتروني أو أية معلومات أخرى تقدمها لنا ونتواصل معك وفقاً لها بما في ذلك رقم هاتفك، من خلال تحديث معلومات التعريف وأية معلومات أخرى ذات صلة بحساب تمارا في أقرب وقت ممكن عملياً وعند الضرورة.',
  },
  {
    type: 'subtitle',
    content: '١٧. القوانين واجبة التطبيق والاختصاص القضائي',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٧</strong> تخضع الحقوق والالتزامات الخاصة بالأطراف المنصوص عليها في الشروط والاحكام للاتفاقية الماثلة وتفسر وتؤوَّل بما يتوافق وأحكام أنظمة الكويت.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٧</strong> تتعهد بموجب الموافقة على هذه الاتفاقية بالخضوع ودون قيد أو شرط مناط الاختصاص الحصري لمحاكم الكويت، وذلك بالنسبة لأي نزاع ينشأ عن الاتفاقية وأي من الشروط والأحكام الماثلة أو يرتبط بها، كما تقر وتتعهد بالتنازل عن حقك في اتخاذ أية إجراءاتٍ قانونية في أي مكان آخر.',
  },
  {
    type: 'subtitle',
    content: '١٨. التعاون في التحقيقات والاستفسارات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٨</strong> بموجب هذه الاتفاقية أنت توافق على التعاون مع تمارا إلى أقصى حد يسمح به القانون والأنظمة المعمول بها في المملكة العربية السعودية، بما في ذلك الموافقة على الإجابة الكتابية عن أية أسئلة أو تقديم معلومات لمساعدة تمارا في إجراء أي تحقيق داخلي أو استفسار.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٨</strong> بموجب هذه الاتفاقية أنت تقر انك موافق على أن تفصح تمارا عن المعلومات الخاصة بك وبحسابك المذكور أو أي حساب آخر يكون، لدى المفوض للشركة السعودية للمعلومات الائتمانية (سمة) من خلال اتفاقية العضوية المبرمة وقواعد العمل المقررة والخاصة بتبادل المعلومات و/ أو لأي جهة أخرى يوافق عليها البنك المركزي السعودي (ساما).',
  },
  {
    type: 'subtitle',
    content: '١٩. استقلالية الشروط والأحكام وقابلية الفصل بينها:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٩</strong> إذا تقرر بطلان أو عدم نفاذ أو عدم سريان أو عدم صلاحية أي شرط أو حكم وارد في هذه الاتفاقية، فيعتبر حينئذٍ ذلك الشرط أو الحكم فقط غير نافذ دون أن يؤثر ذلك وبأي حال من الأحوال على باقي الشروط والاحكام التي تظل سارية وترتب كافة آثارها.',
  },
  {
    type: 'subtitle',
    content: '٢٠. سريان إنهاء الاتفاقية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٢٠</strong> تسري هذه الاتفاقية في التاريخ الذي تنقر فيه للإشارة إلى موافقتك على شروطها وتظل سارية وينصرف أثرها إلى الورثة.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٢٠</strong> يجوز إنهاء هذه الاتفاقية في أي وقت من قبل أي من الطرفين بسبب أو بدون سبب.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٢٠</strong> إذا قررت تمارا إنهاء هذه الاتفاقية، فستقوم بإبلاغك بذلك عن طريق إرسال إخطار إلى عنوان البريد الإلكتروني الذي قدمته لشركة تمارا، كما توافق وتقر بموجب هذه الاتفاقية بأن تمارا لديها الحق المطلق في إنهاء هذه الاتفاقية بسبب أو بدون سبب مع عدم التزامها بإبلاغك بسبب إنهاء الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٢٠</strong> لك إنهاء هذه الاتفاقية عن طريق إغلاق حساب تمارا الخاص بك من خلال اتباع التعليمات الموجودة على موقع تمارا الإلكتروني، ولتجنب الشك ستبقى أنت مسؤولاً عن جميع الالتزامات المتعلقة بحساب تمارا حتى بعد إغلاقه وقيامك بإنهاء هذه الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.٢٠</strong> يجوز لك طلب إغلاق حساب تمارا الخاص بك في أي وقت باتباع التعليمات الموجودة على موقع تمارا الإلكتروني إذا لم يكن هناك أية مبالغ مستحقة عليك لصالح تمارا بخصوص خدمات الدفع من تمارا وستبقى مسؤولًا عن جميع الالتزامات المتعلقة بحساب تمارا حتى بعد إغلاقه.',
  },
  {
    type: 'subtitle',
    content: '٢١. مُجمل الاتفاق:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٢١</strong> تمثل الاتفاقية وكل ما ورد بها من شروط وأحكام مجمل الاتفاق وما تم الاتفاق والتوافق والتفاهم بشأنه بينك وبين تمارا، كما تشمل ما قد يطرأ عليها من تحديث من حين لآخر وما يتم نشره بشأنها على الموقع الإلكتروني الخاص بنا، وتلغي هذه الاتفاقية وتنسخ أي مما سبقها من اتفاقات أخرى من أي نوع.',
  },
]
